import React, { useEffect } from 'react';
import { PAYMENT_METHODS } from '../../constants';
import { setSelectedPaymentMethod } from '../../../../store/slices/payment/paymentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedPaymentMethod } from '../../../../store/slices/payment/paymentSelectors';
import {
  selectConfigEnableACH,
  selectConfigEnableCC,
  selectConfigEnableCheck,
} from '../../../../store/slices/config/configSelectors';
import { ControlledPaymentMethodSelector } from './ControlledPaymentMethodSelector';
import { PaymentMethod } from 'src/types/payment';

interface PaymentMethodSelectorProps {
  singlePaymentButton?: boolean;
}

const PaymentMethodSelector = ({
  singlePaymentButton,
}: PaymentMethodSelectorProps) => {
  const dispatch = useDispatch();
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);

  const creditCardEnabled = useSelector(selectConfigEnableCC);
  const achDirectDebitEnabled = useSelector(selectConfigEnableACH);
  const checkEnabled = useSelector(selectConfigEnableCheck);

  useEffect(() => {
    const getFirstEnabledPaymentMethod = () => {
      if (achDirectDebitEnabled) return PAYMENT_METHODS.ACH_DIRECT_DEBIT;
      if (creditCardEnabled) return PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD;
      if (checkEnabled) return PAYMENT_METHODS.CHECK;
      return '';
    };
    const paymentMethod = getFirstEnabledPaymentMethod();
    dispatch(setSelectedPaymentMethod(paymentMethod));
  }, [creditCardEnabled, achDirectDebitEnabled, checkEnabled, dispatch]);

  const handleSetSelectedPaymentMethod = (paymentMethod: PaymentMethod) => {
    dispatch(setSelectedPaymentMethod(paymentMethod));
  };

  return (
    <ControlledPaymentMethodSelector
      achEnabled={achDirectDebitEnabled}
      ccEnabled={creditCardEnabled}
      checkEnabled={!!checkEnabled}
      onSelectPaymentMethod={handleSetSelectedPaymentMethod}
      paymentMethod={selectedPaymentMethod}
      singlePaymentButton={singlePaymentButton}
    />
  );
};

export default PaymentMethodSelector;
